import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDate } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { auditMentionsAuditMentionsReportsScheduleStatus } from '@mi-front/api-v2';
import { DateStr, PntStationStatusReportDtoV2 } from '@mi-front/core';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../../../core/reports/types';
import { ScheduleStatusMentionsForm } from './ScheduleStatusMentionsForm';
import { ScheduleStatusMentionsResult } from './ScheduleStatusMentionsResult';

interface Props {
  readonly station: Station;
}

export type ScheduleStatusMentionsReport = ReportType<
  { date: DateStr; customId: string },
  PntStationStatusReportDtoV2
>;

/**
 * Mentions schedule-status report for a station/day via api-v2.
 */
export function ScheduleStatusMentionsView(p: Props) {
  return (
    <ReportView<ScheduleStatusMentionsReport>
      defaultValues={{
        date: getAuditListingDefaultDate(),
        customId: '',
      }}
      runOnLoad
      download={false}
      getResultCount={(result) => result.items.length}
      queryParamsTransform={{
        customId: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      reportFn={async (values) => {
        return auditMentionsAuditMentionsReportsScheduleStatus(
          {
            date: values.date,
            customId: values.customId || undefined,
          },
          { station: p.station.id },
        ) as Promise<PntStationStatusReportDtoV2>;
      }}
      Form={ScheduleStatusMentionsForm}
      Result={ScheduleStatusMentionsResult}
    />
  );
}
